import { Helmet } from "react-helmet-async";
import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  MenuItem,
  Container,
  Grid,
  Typography,
  InputLabel,
  FormControl,
  Box,
  CircularProgress,
} from "@mui/material";
import Select from "@mui/material/Select";
import axios from "axios";
import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------

export default function NewGamePage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [match, setMatch] = useState("");
  const [matches, setMatches] = useState(null);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_FEED_BASE_URL}/feeds/nhl/fixtures?token=${process.env.REACT_APP_FEED_TOKEN}`
      )
      .then(function (response) {
        setMatches(response.data);
      });
  }, []);

  const handleChange = (event) => {
    setMatch(event.target.value);
  };

  const handleSubmit = () => {
    let matchData = matches.find((item) => item.id === match);
    if (matchData) {
      setLoading(true);
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/admin/games`, {
          matchId: matchData.id,
          name: `${matchData.home_team.name} vs ${matchData.away_team.name}`,
          kickoff: matchData.start_utc,
        })
        .then(function (response) {
          navigate("/dashboard/picks");
        });
    }
  };
  return (
    <>
      <Helmet>
        <title> Bingo Games </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Create Bingo Game
          </Typography>
        </Stack>

        <Card style={{ padding: 20 }}>
          {matches === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl sx={{ m: 1, minWidth: 620 }} size="small">
                  <InputLabel id="demo-simple-select-label">Match</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={match}
                    label="Match"
                    onChange={handleChange}
                  >
                    {matches.map((match) => (
                      <MenuItem value={match.id} key={match.id}>
                        {match.home_team.name} vs {match.away_team.name} |{" "}
                        {match.start_utc}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Button
                  variant="contained"
                  disabled={match === ""}
                  onClick={() => handleSubmit()}
                >
                  Create
                </Button>
              </Grid>
            </Grid>
          )}
        </Card>
      </Container>
    </>
  );
}
